import React, {useEffect} from "react";
import ExportComponent from "../../components/export.component";
import UncompleteOrderStatisticComponent from "./uncomplete-order-statistic.component";
import UncompleteOrderChartComponent from "./uncomplete-order-chart.component";
import FilterComponent from "./filter.component";
import OrderListComponent from "./order-list.component";
import TotalDataComponent from "../../components/total-data.component";
import DateRangePickerComponent from "../../components/date-range-picker.component";
import {useDispatch, useSelector} from "react-redux";
import {
    setToolsInitialState,
    setToolsLoading,
    setToolsStartDateEndDate,
    setToolsTotalData
} from "../../reducers/tools.reducer";
import {exportUnCompleteOrderApi, getIncompleteOrderListApi} from "../../api/service-performance.api";
import {dateRangeToday, formatDateToReadable, generateExportFileName} from "../../ui-utils/general-variable";
import {setServicePerformanceIncompleteOrderList} from "../../reducers/service-performance.reducer";

export const UncompleteOrderComponent = () => {
    const dispatch = useDispatch()
    const {
        dateRange,
        currentPage,
        pageSize,
        searchKey,
        orderBy,
        sort,
        expedition
    } = useSelector(state => state.toolsReducer)

    const getValueFromRangePickerSingle = (d) => {
        dispatch(setToolsStartDateEndDate(d))
    }

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
        }
    }, [])

    useEffect(() => {
        if (!dateRange[0]) {
            dispatch(setToolsStartDateEndDate(dateRangeToday))
        } else {
            let params = {
                page: currentPage,
                perPage: pageSize,
                orderBy: !!orderBy ? orderBy : 'id',
                orderType: sort,
                filterByExpedition: expedition?.key || null,
                search: searchKey,
                startDate: formatDateToReadable(dateRange[0], 'YYYY-MM-DD'),
                endDate: formatDateToReadable(dateRange[1], 'YYYY-MM-DD'),
            }
            dispatch(setToolsLoading(true))
            getIncompleteOrderListApi(params)
                .then(response => {
                    dispatch(setToolsTotalData(response.total_result))
                    dispatch(setToolsLoading(false))
                    dispatch(setServicePerformanceIncompleteOrderList(response.result))
                })
                .catch(err => {
                    if (err?.code === '503-0000') {
                        localStorage.clear()
                        window.location.href = '/under-maintenance'
                    }
                    console.log(err)
                    dispatch(setToolsLoading(false))
                })
        }
    }, [currentPage, pageSize, expedition, dateRange, searchKey, orderBy, sort])

    const exportHandler = () => {
        let requestBody = {
            "order_by": !!orderBy ? orderBy : 'id',
            "order_type": sort,
            "start_date": dateRange[0] ? formatDateToReadable(dateRange[0], "YYYY-MM-DD") : null,
            "end_date": dateRange[1] ? formatDateToReadable(dateRange[1], "YYYY-MM-DD") : null,
            "filter_by_expedition": expedition?.key || null,
            search: searchKey
        }

        exportUnCompleteOrderApi(requestBody)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${generateExportFileName('Pesanan Tidak Terselesaikan')}`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => {
                if (err?.code === '503-0000') {
                    localStorage.clear()
                    window.location.href = '/under-maintenance'
                }
                console.log(err)
            })
    }

    return (
        <div className={"space-y-5 box-content-style py-5"}>
            <div className={"p-5 space-y-5"}>
                <div className={"row items-center justify-between"}>
                    <div/>
                    <DateRangePickerComponent onChange={getValueFromRangePickerSingle}/>
                    <ExportComponent exportHandler={exportHandler}/>
                </div>
                <UncompleteOrderStatisticComponent/>
                <UncompleteOrderChartComponent/>
                <FilterComponent/>
            </div>
            <div>
                <TotalDataComponent/>
                <OrderListComponent/>
            </div>
        </div>
    )
}
